module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container page-container"
  }, [_c('h1', [_vm._v("Your Projects")]), _vm._v(" "), (_vm.user.isAdmin) ? _c('div', {
    staticClass: "add-project"
  }, [_c('el-form', {
    ref: "addProjectForm",
    staticClass: "form-inline",
    attrs: {
      "inline": true,
      "model": _vm.newProject,
      "rules": _vm.rules,
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Project Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Name"
    },
    model: {
      value: (_vm.newProject.name),
      callback: function($$v) {
        _vm.newProject.name = $$v
      },
      expression: "newProject.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " "
    }
  }, [_c('el-button', {
    staticClass: "btn-add",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addproject('addProjectForm')
      }
    }
  }, [_vm._v("Add  "), _c('i', {
    staticClass: "el-icon-plus el-icon-right"
  })])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.user.isAdmin !== true) ? _c('div', [(_vm.auth.user !== null) ? _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, _vm._l((_vm.userProjects), function(project, index) {
    return _c('el-col', {
      key: project.name,
      attrs: {
        "xs": 24,
        "sm": 24,
        "md": 12,
        "lg": 12
      }
    }, [_c('el-card', {
      staticClass: "box-card"
    }, [_c('div', {
      staticClass: "text item"
    }, [_c('span', {
      staticClass: "project-title"
    }, [_vm._v(_vm._s(project.name))]), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push('/projects/' + project['.key'])
        }
      }
    }, [_vm._v("Manage")]), _vm._v(" "), _c('span', {
      staticClass: "edited"
    }, [_vm._v("Edited: " + _vm._s(_vm.prettyDate(project.edited)))])], 1)])], 1)
  })) : _vm._e(), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), (_vm.user.isAdmin == true) ? _c('div', [(_vm.auth.user !== null) ? _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, _vm._l((_vm.projects), function(project, index) {
    return _c('el-col', {
      key: project.name,
      attrs: {
        "xs": 24,
        "sm": 24,
        "md": 12,
        "lg": 12
      }
    }, [_c('el-card', {
      staticClass: "box-card"
    }, [_c('div', {
      staticClass: "text item"
    }, [_c('span', {
      staticClass: "project-title"
    }, [_vm._v(_vm._s(project.name))]), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push('/projects/' + project['.key'])
        }
      }
    }, [_vm._v("Manage")]), _vm._v(" "), _c('span', {
      staticClass: "edited"
    }, [_vm._v("Edited: " + _vm._s(_vm.prettyDate(project.edited)))])], 1)])], 1)
  })) : _vm._e(), _vm._v(" "), _c('br')], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e7071a8c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects.vue
// module id = 338
// module chunks = 2